// extracted by mini-css-extract-plugin
export default {"DrawerTitle":"RightDrawer_DrawerTitle__fFqzW"};